import { Pipe, PipeTransform } from '@angular/core';
import { ImportRequest } from '../models';
import { ImportRequestStatus } from '../models/import-request-status';

@Pipe({
  name: 'filterImportRequests',
  pure: false,
  standalone: false
})
export class FilterImportRequestsPipe implements PipeTransform {
  transform(items: ImportRequest[], filter: string, isMostRecentOnly: boolean = true): ImportRequest[] {

    if (!items) {
      return items;
    }

    // Are we only showing most recent?
    if (isMostRecentOnly) {
      items = items.filter((x: ImportRequest) =>
        x.statusId !== ImportRequestStatus.NewRequestReceived
                && x.statusId !== ImportRequestStatus.Processed);
    }

    if (!filter) {
      return items;
    }

    return items.filter((x: ImportRequest) =>
      x.propertyName.toUpperCase().indexOf(filter.toUpperCase()) >= 0
            || x.propertyCity.toUpperCase().indexOf(filter.toUpperCase()) >= 0
    );
  }
}
